export default __webpack_public_path__ + "c2799af76eb7c913c49a0f48482ea6c2.wav";